// Glob is relative to this file (resources/js/utils/themeCss.ts).
// Theme CSS files live at resources/js/themes/{storeCode}/assets/theme.css.
const themeCssModules = import.meta.glob('../themes/**/*.css');

/**
 * Dynamically loads a theme-specific CSS file alongside the default styles.
 * Place the file at: resources/js/themes/{storeCode}/assets/theme.css
 *
 * This function is a no-op during SSR.
 */
export async function loadThemeCss(storeCode: string): Promise<void> {
    if (typeof window === 'undefined') {
        return;
    }

    const key: string = `../themes/${storeCode}/assets/theme.css`;

    if (!themeCssModules[key]) {
        return;
    }

    await themeCssModules[key]();
}
